export const GET_LISTDATA = "getListData";
export const SET_LISTDATA = "setListData";
export const GET_DETAILDATA = "getDetailData";
export const SET_DETAILDATA = "setDetailData";
export const GET_FORMPOST = "getFormPost";
export const SET_FORMPOST = "setFormPost";

// HRMS module: separate action types so HRMS list/form/detail traffic
// (served under /api/employee/*) never shares state with the main app's
// generic listdata/detaildata/formpost slices (served under /apiv1/*).
export const GET_EMP_LISTDATA = "getEmpListData";
export const SET_EMP_LISTDATA = "setEmpListData";
export const GET_EMP_DETAILDATA = "getEmpDetailData";
export const SET_EMP_DETAILDATA = "setEmpDetailData";
export const GET_EMP_FORMPOST = "getEmpFormPost";
export const SET_EMP_FORMPOST = "setEmpFormPost";
